import PropTypes from 'prop-types';

export const textFieldPropType = PropTypes.shape({
  isInitialized: PropTypes.bool.isRequired,
  isValid: PropTypes.bool.isRequired,
  value: PropTypes.string.isRequired,
  errorMessage: PropTypes.string,
  errorMessageTKey: PropTypes.string,
}).isRequired;

export const dateFieldPropType = PropTypes.shape({
  isInitialized: PropTypes.bool.isRequired,
  isValid: PropTypes.bool.isRequired,
  errorMessage: PropTypes.string,
  errorMessageTKey: PropTypes.string,
  value: PropTypes.string,
}).isRequired;

export const boolFieldPropType = PropTypes.shape({
  isInitialized: PropTypes.bool.isRequired,
  isValid: PropTypes.bool.isRequired,
  errorMessage: PropTypes.string,
  errorMessageTKey: PropTypes.string,
  value: PropTypes.bool,
}).isRequired;

export const addressPropType = PropTypes.shape({
  city: textFieldPropType,
  country: textFieldPropType,
  postalCode: textFieldPropType,
  street: textFieldPropType,
});

export const defaultStakeholderContainerPropTypes = {
  defaultRole: PropTypes.string.isRequired,
  defaultStakeholders: PropTypes.array.isRequired,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  roleConstraints: PropTypes.object.isRequired,
  stakeholders: PropTypes.array.isRequired,
  cantHaveRole: PropTypes.array,
};
